import { render, staticRenderFns } from "./SerchAttractions.vue?vue&type=template&id=0f42279d&scoped=true&"
import script from "./SerchAttractions.vue?vue&type=script&lang=js&"
export * from "./SerchAttractions.vue?vue&type=script&lang=js&"
import style0 from "./SerchAttractions.vue?vue&type=style&index=0&id=0f42279d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f42279d",
  null
  
)

export default component.exports